define.alias("shared/components/shared/ui/button", "settings/components/shared/ui/button");